import {HTTP} from "@/helpers/http-common"

const urlModule = 'comercio'

const get = (comercio) => new Promise((resolve,reject)=>{
  const {clave} = comercio;
  HTTP.get(
    `/api/${urlModule}/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const save = (comercio) =>new Promise((resolve,reject)=>{
  const {clave, name, email, tipoArchivo, status
    , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
    // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
    , puertoBuzonEntrada
    // , puertoBuzonRecepcion
    , locationAddress
    , locationCity
    , locationRegionCode
    , locationCountryCode
    , locationPostalCode
    , consecutivoArchivosGenerados
    , numeroComercio
    , formatoRespueta
    , contenidoRespuesta
    , summitterId
    , nombreArchivo
    , nombreArchivoGSFG
    , nombreArchivoRespuesta
    , tiempoMaximoEsperaRespuesta
    , esperaRespuesta
    , fechaFinEsperaRespuesta
    , tiempoMaximoAdvertenciaRespuesta
    , advertenciaRespuesta
    , fechaFinAdvertenciaRespuesta
    , mcc
    , multipleSucursal
    , sucursalEnEspera
    , nombreArchivoCartRefresh
    , nombreArchivoCartRefreshCarga
    , enviarCorreoSFTP
  } = comercio;
  HTTP
  .post(
    `/api/${urlModule}`
    , {clave, name, email, tipoArchivo, status
      , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
      // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
      , puertoBuzonEntrada
      // , puertoBuzonRecepcion
      , locationAddress
      , locationCity
      , locationRegionCode
      , locationCountryCode
      , locationPostalCode
      , consecutivoArchivosGenerados
      , numeroComercio
      , formatoRespueta
      , contenidoRespuesta
      , summitterId
      , nombreArchivo
      , nombreArchivoGSFG
      , nombreArchivoRespuesta
      , tiempoMaximoEsperaRespuesta
      , esperaRespuesta
      , fechaFinEsperaRespuesta
      , tiempoMaximoAdvertenciaRespuesta
      , advertenciaRespuesta
      , fechaFinAdvertenciaRespuesta
      , mcc
      , multipleSucursal
      , sucursalEnEspera
      , nombreArchivoCartRefresh
      , nombreArchivoCartRefreshCarga
      , enviarCorreoSFTP
    }
  ).then(response=>{
    console.log(response)
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const update = (comercio) =>new Promise((resolve,reject)=>{
  const {clave, name, email, tipoArchivo, status
    , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
    // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
    , puertoBuzonEntrada
    // , puertoBuzonRecepcion
    , locationAddress
    , locationCity
    , locationRegionCode
    , locationCountryCode
    , locationPostalCode
    , consecutivoArchivosGenerados
    , numeroComercio
    , formatoRespueta
    , contenidoRespuesta
    , summitterId
    , nombreArchivo
    , nombreArchivoGSFG
    , nombreArchivoRespuesta
    , tiempoMaximoEsperaRespuesta
    , esperaRespuesta
    , fechaFinEsperaRespuesta
    , tiempoMaximoAdvertenciaRespuesta
    , advertenciaRespuesta
    , fechaFinAdvertenciaRespuesta
    , mcc
    , multipleSucursal
    , sucursalEnEspera
    , nombreArchivoCartRefresh
    , nombreArchivoCartRefreshCarga
    , enviarCorreoSFTP
  } = comercio;
  HTTP
  .put(
    `/api/${urlModule}`
    , {clave, name, email, tipoArchivo, status
      , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
      // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
      , puertoBuzonEntrada
      // , puertoBuzonRecepcion
      , locationAddress
      , locationCity
      , locationRegionCode
      , locationCountryCode
      , locationPostalCode
      , consecutivoArchivosGenerados
      , numeroComercio
      , formatoRespueta
      , contenidoRespuesta
      , summitterId
      , nombreArchivo
      , nombreArchivoGSFG
      , nombreArchivoRespuesta
      , tiempoMaximoEsperaRespuesta
      , esperaRespuesta
      , fechaFinEsperaRespuesta
      , tiempoMaximoAdvertenciaRespuesta
      , advertenciaRespuesta
      , fechaFinAdvertenciaRespuesta
      , mcc
      , multipleSucursal
      , sucursalEnEspera
      , nombreArchivoCartRefresh
      , nombreArchivoCartRefreshCarga
      , enviarCorreoSFTP
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const disable = (comercio) =>new Promise((resolve,reject)=>{
  const {clave} = comercio;
  HTTP
  .delete(
    `/api/${urlModule}`
    , {
      params:{clave}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const unlock = (comercio) =>new Promise((resolve,reject)=>{
  const {clave} = comercio;
  HTTP
  .delete(
    `/api/${urlModule}/unlock`
    , {
      params:{clave}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

const adelantarEsperaRespuesta = (comercio) =>new Promise((resolve,reject)=>{
  console.log("adelantarEsperaRespuesta4");
  const {clave} = comercio;
  HTTP
  .delete(
    `/api/${urlModule}/adelantarEsperaRespuesta`
    , {
      params:{clave}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});
const cambiarFechaEsperaRespuesta = (comercio) =>new Promise((resolve,reject)=>{
  console.log("emitAdelantarEsperaRespuesta4");
  const {clave} = comercio;
  HTTP
  .delete(
    `/api/${urlModule}/cambiarFechaEsperaRespuesta`
    , {
      params:{clave}
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

//Export methods
export default{
  get
  , save
  , update
  , disable
  , unlock
  , adelantarEsperaRespuesta
  , cambiarFechaEsperaRespuesta
}



// WEBPACK FOOTER //
// ./src/services/generales/comercio/index.js